<template>
  <div id="adverseRecordFrame">
    <!-- <el-tabs v-model="tabAction" >
      <el-tab-pane
        v-for="item in tabs"
        :key="item.name"
        :label="item.label"
        :name="item.name"
      >
      </el-tab-pane>
    </el-tabs> -->
    <component :is="tabAction"></component>
  </div>
</template>

<script>
import adverseRecord from "./adverseRecord.vue";
export default {
  name: "adverseRecordFrame",
  components: {
    adverseRecord,
  },
  data() {
    return {
      tabs: [
        {
          label: "背景审核",
          name: "adverseRecord",
        },
      ],
      tabAction: "adverseRecord",
    };
  },

  methods: {},
};
</script>

<style>

</style>